import { useCallback, useState } from 'react';
import { reduce } from 'lodash/collection';
import { isString } from 'lodash/lang';
import { has } from 'lodash/object';

export default function useChangeRequest() {
  const [changeRequests, setChangeRequests] = useState({});

  return [
    changeRequests,
    useCallback(function(request) {
      if (!request) {
        return;
      }
      if (isString(request)) {
        setChangeRequests(function(changeRequests) {
          return reduce(
            changeRequests,
            function(accumulator, value, key) {
              if (has(value, request)) {
                delete value[request];
                accumulator[key] = { ...value };
              }
              return accumulator;
            },
            { ...changeRequests }
          );
        });
        return;
      }

      const { affectedFieldNames, optionOriginName, optionNextName } = request;

      setChangeRequests(function(changeRequests) {
        return affectedFieldNames.reduce(
          function(accumulator, fieldName) {
            if (!accumulator[fieldName]) {
              accumulator[fieldName] = {};
            }

            accumulator[fieldName][optionOriginName] = optionNextName;

            return accumulator;
          },
          { ...changeRequests }
        );
      });
    }, [])
  ];
}
